export function hasConfiguredCourseCoupon(course) {
  return typeof course?.codigoDescuento === "string" && course.codigoDescuento.trim() !== "";
}

export function getCourseCheckoutPrice(course) {
  if (hasConfiguredCourseCoupon(course)) {
    const basePrice = Number(course?.precio);
    if (Number.isFinite(basePrice)) return basePrice;
  }
  const finalPrice = Number(course?.precioFinal);
  if (Number.isFinite(finalPrice)) return finalPrice;
  const basePrice = Number(course?.precio);
  return Number.isFinite(basePrice) ? basePrice : 0;
}
